document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper !== 'undefined') {
    initSwiper();
  } else {
    // Wait for Swiper to load if deferred
    window.addEventListener('load', initSwiper);
  }

  function initSwiper() {
    const swiperContainers = document.querySelectorAll('.da-upsell-swiper');

    swiperContainers.forEach(container => {
      // Check if already initialized to avoid double init
      if (container.classList.contains('swiper-initialized')) return;

      new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true, // Optional: loop slides
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 1, // Keep 1 on mobile/tablet based on image design? Or 2? Let's stick to 1 for now or 2 for tablet.
          },
          1024: {
            slidesPerView: 1, // The image shows 1 slide at a time with pagination? 
            // Wait, the prompt image shows ONE card. But usually upsells have multiple. 
            // If the user wants "slider", usually implies multiple items.
            // Let's assume 1 per view for this specific "card" design as it is quite wide.
          },
        },
      });
    });
  }

  // AJAX Add to Cart
  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('js-da-upsell-add-btn')) {
      e.preventDefault();
      const button = e.target;
      const variantId = button.getAttribute('data-variant-id');

      if (!variantId) return;

      addToCart(variantId, button);
    }
  });

  function addToCart(variantId, button) {
    button.classList.add('loading');
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        button.classList.remove('loading');
        button.textContent = 'Added';

        // Reset button text after 2 seconds
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);

        // Refresh cart or open drawer if theme supports it
        // Dispatch an event that many themes listen to
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        // Also try standard Shopify events
        document.dispatchEvent(new CustomEvent('cart:add', {
          bubbles: true,
          detail: data
        }));

        // Update cart count bubble if exists
        updateCartCount();

      })
      .catch((error) => {
        console.error('Error:', error);
        button.classList.remove('loading');
        button.textContent = 'Error';
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      });
  }

  function updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountBubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
        cartCountBubbles.forEach(bubble => {
          bubble.textContent = cart.item_count;
          if (cart.item_count > 0) bubble.classList.remove('hidden');
        });
      });
  }
});
